import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { ImportUtilityModel } from '../../typings'
import { ISalesTeam } from '@user/store/salesTeam'
import { ISalesFunnel } from '@user/store/salesFunnel'

export function useHandlers() {
  const { setValues } = useFormikContext<ImportUtilityModel>()

  const onChangeSalesTeam = useCallback(
    (value: ISalesTeam | null) => {
      if (value?.id) {
        setValues((previousValues) => ({
          ...previousValues,
          salesTeamId: String(value?.id),
          salesTeamName: value?.name || '',
        }))
      }
    },
    [setValues],
  )

  const onChangeSalesFunnel = useCallback(
    (value: ISalesFunnel | null) => {
      if (value?.id) {
        setValues((previousValues) => ({
          ...previousValues,
          salesFunnelId: String(value?.id),
          salesFunnelName: value?.name || '',
        }))
      }
    },
    [setValues],
  )

  return {
    onChangeSalesTeam,
    onChangeSalesFunnel,
  }
}
